import { Result } from 'antd';
import Animate from 'rc-animate';
import React from 'react';
import { FormattedMessage } from 'react-intl';

export const ErrorBoundaryFallback = (): React.ReactElement => {
  const Exception = () => (
    <Result
      status="403"
      title={<FormattedMessage id="toolbar.info_panel_error" />}
      subTitle={<FormattedMessage id="error" />}
      style={{ width: '100vw' }}
    />
  );

  return (
    <Animate transitionName="fade" transitionAppear>
      <Exception />
    </Animate>
  );
};
